// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1giro","content":"styles_content__3Z_Zr","selectAll":"styles_selectAll__1vDFG"};